var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFidelidade40X = function SvgFidelidade40X(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.616 21.616c0 11.04-8.96 20-20 20s-20-8.96-20-20 8.96-20 20-20M41.616 9.616v-8h-8M31.616 11.616l10-10",
    stroke: "#106B55",
    strokeWidth: 3.232,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.953 13.1c2.957.365 4.477 1.57 4.477 3.281 0 1.542-1.658 2.748-1.769 2.636-1.216-1.122-2.985-1.879-4.56-1.879-1.52 0-2.211.477-2.211 1.318 0 .953 1.299 1.177 3.04 1.57 2.35.477 5.887 1.514 5.887 5.215 0 2.944-1.714 4.85-4.892 5.467v.701c0 1.71-.636 2.608-2.156 2.608h-.138c-1.576 0-2.156-.842-2.156-2.608v-.56c-3.29-.365-5.058-1.683-5.058-3.477 0-1.458 1.548-2.636 1.658-2.496 1.134 1.01 3.262 1.935 5.086 1.935 1.575 0 2.294-.449 2.294-1.318 0-.981-1.299-1.233-2.93-1.598-2.266-.476-5.721-1.43-5.721-5.299 0-2.804 1.714-4.71 4.699-5.355v-.617c0-1.71.635-2.607 2.155-2.607h.139c1.575 0 2.155.84 2.155 2.607v.477Z",
    fill: "#106B55"
  })));
};
export default SvgFidelidade40X;